<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper2.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="2" :rightBars="rightBars"></menutree>
    <div class="aboutus_content_box">
      <div class="aboutus_content">
        <div style="font-weight: bolder;">
          1、建设项目职业病危害预评价
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为建设单位依法履行《中华人民共和国职业病防治法》第十七条的规定提供评价技术服务：新建、扩建、改建建设项目和技术改造、技术引进项目可能产生职业病危害的建设单位，编制《建设项目职业病危害与评价报告书》，为保障建设单位职业健康管理的依法规范经营提供技术依据和技术服务。
        </p>
        <div style="font-weight: bolder;">
          2、建设项目职业病防护设施设计
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为建设单位依法履行《中华人民共和国职业病防治法》第十八条的规定提供技术服务：建设项目的职业病防护设施设计应当符合国家职业卫生标准和卫生要求；《浙江省建设项目职业病防护设施“三同时”监督管理实施细则》第十四条，存在职业病危害的建设项目，建设单位应当在施工前按照职业病防治有关法律、法规、规章和标准的要求，进行职业病防护设施设计。为保障建设单位职业健康管理的依法规范经营提供技术依据和技术服务。
        </p>
        <div style="font-weight: bolder;">
          3、建设项目职业病危害控制效果评价
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为建设单位依法履行《中华人民共和国职业病防治法》第十八条的规定提供评价技术服务：建设项目在竣工验收前，建设单位应当进行职业病危害控制效果评价。为保障建设单位职业健康管理的依法规范经营提供技术依据和技术服务。
        </p>
        <div style="font-weight: bolder;">
          4、用人单位职业病危害现状评价
        </div>
        <p style="text-indent:2em;">
          本机构受用人单位委托，根据国家卫生健康委员会令第5号第二十条提供评价技术服务：职业病危害严重的用人单位，应当委托具有相应资质的职业卫生技术服务机构，每三年至少进行一次职业病危害现状评价。第二十一条：存在职业病危害的用人单位发生职业病危害事故或者国家卫生健康委规定的其他情形的，应当及时委托具有相应资质的职业卫生技术服务机构进行职业病危害现状评价。
        </p>
        <div style="font-weight: bolder;">
          5、工作场所职业病危害因素检测与评价（定期检测）
        </div>
        <p style="text-indent:2em;">
          本机构受用人单位委托，根据《中华人民共和国职业病防治法》第二十六条的规定提供检测评价服务：用人单位应当按照国务院卫生行政部门的规定，定期对工作场所进行职业病危害因素检测、评价。检测、评价结果存入用人单位职业卫生档案，定期向所在地卫生行政部门报告并向劳动者公布。职业病危害因素检测、评价由依法设立的取得国务院卫生行政部门或者设区的市级以上地方人民政府卫生行政部门按照职责分工给予资质认可的职业卫生技术服务机构进行。职业卫生技术服务机构所作检测、评价应当客观、真实。
        </p>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      menuchild:[{
          lable:'职业卫生检测与评价',
          value:'2',
          path:'/occupationalHygiene'
        },{
          lable:'安全技术服务',
          value:'1',
          path:'/safetyAssessment'
        },{
          lable:'环保技术服务',
          value:'3',
          path:'/environmentDetection'
        }],
        rightBars:[{
          lable:'首页',
          path:'/',
        },{
          lable:'服务项目',
          path:'',
        },{
          lable:'职业卫生',
          path:'',
      }]
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .aboutus_content_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .aboutus_content{
      width: 1200px;
      min-height: 700px;
      padding:40px 0;
      font-size: 15px;
      color: #666;
      line-height: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/serviceItems/occupationalHygiene.vue